<template>
  <div>
    <div
      id="modal-title"
      class="modal-header"
    >
      <h3>{{ $t('user.create') }}</h3>
    </div>
    <div class="modal-content">
      <form
        id="form-create-user"
        action=""
      >
        <div class="input-group">
          <div class="input input-text">
            <label for="username">{{ $t('username') }}</label>
            <input
              id="username"
              v-model="newUsername"
              type="text"
              placeholder="ist123456"
              required
              @keypress.enter="createOperator($event)"
            >
          </div>
        </div>

        <div
          v-if="currentUser"
          class="label-user"
        >
          <div class="avatar">
            <img :src="currentUser.avatar">
          </div>
          <div>{{ currentUser.name }}</div>
          <div>{{ currentUser.username }}</div>
        </div>

        <div class="form-actions">
          <button
            type="button"
            class="btn-secondary"
            @click="close"
          >
            {{ $t('cancel') }}
          </button>
          <button
            type="button"
            class="btn-primary btn-active main-action"
            @click="createOperator()"
          >
            {{ $t('create') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import usersAPI from '@/api/users'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'CreateOperator',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    serviceID: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      open: false,
      newUsername: null
    }
  },
  computed: {
    ...mapState([
      'services',
      'currentUser'
    ])
  },
  watch: {
    newUsername: function (newUsername, oldUsername) {
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
      this.timeout = setTimeout(async () => {
        await this.fetchFenixUser({ username: newUsername })
      }, 800)
    }
  },
  beforeDestroy () {
    this.clearFenixUser()
  },
  methods: {
    async close () {
      this.$emit('input', false)
    },
    async createOperator () {
      await usersAPI.createUser({ service: this.serviceID, type: 'operator', username: this.newUsername })
      this.fetchUsers({ service: this.serviceID, type: 'operator' })
      this.close()
    },
    ...mapActions([
      'fetchUsers',
      'fetchFenixUser',
      'clearFenixUser'
    ])
  }
}

</script>
